import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleProject = {
  namespaced: true,

  state: {
    name: 'project',
    nextSeqCode: null,

    project: null,
    projects: [],

    projectNames: [],
    projectStatuses: [],

    projectVessels: [],
    projectVesselIds: [],

    projectsMap: {},
    statusesMap: {},
  },

  mutations,
  getters,
  actions
}

export default moduleProject;